import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteThirdPartyConfig(props) {

  return (
    <BasicModal
      popupOpen={props?.deleteThirdPartyPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Hotel Brand<br/> <b>{props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}</b> ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Hotel Brand "{props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}" will be permanently deleted <br />
              Deleting the specified Hotel Brand can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeleteThirdPartyRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}</label>
              </div>
              {(props?.confirmDeleteThirdPartyRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}</small></p>
              ) : (props?.confirmDeleteThirdPartyRow !== `Delete ${props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData.row.brandName}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isThirdPartyDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isThirdPartyDeletedRef.current?.isThirdPartyDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteThirdPartyHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteThirdPartyConfig;
